import Qs from 'qs';
export const getSearchParams = (filterSearchParams: any) => {
  delete filterSearchParams?.params?.hideLoader;
  return Qs.stringify(filterSearchParams);
};
